//assumes knockout is loaded
import AccountUser from "./AccountUser.js";
/**
 * Account model
 * @name Account
 * @class
 */
class Account
{
	constructor(options)
	{
		this.account_id = ko.observable(options.account_id);
		this.account_name = ko.observable(options.account_name);
		this.company_name = ko.observable(options.company_name);
		this.account_owner = ko.observable(new AccountUser(options));
		this.user_id = this.account_owner().user_id;
		this.username = this.account_owner().username;
		this.email = this.account_owner().email;
		this.user_active = this.account_owner().user_active;
		this.account_users = ko.observableArray();
	}

	/**
	  * Function to load an account
	  * @memberof Account
	  * @instance
	  */
	async load(account_id){

	}

	/**
	  * Function to delete an account
	  * @memberof Account
	  * @instance
	  */
	async delete(){

		let delete_account = await PSCM.prompt({
			title: 'Delete Account',
			message: `Are you sure you want to delete account "${this.account_name()}"`,
			accept_text: 'Delete',
			type: 'warning'
		});

		if (!delete_account)
			return;

		let options = {};
		if (PSCM.isAdminUser()) {
			let force_delete = await PSCM.prompt({
				title: 'Force Delete',
				message: `Delete Account "${this.account_name()}" and all of its Installations? Please note this will not actually remove the installations from their respective hosts.`,
				cancel_text: 'Delete Only Account',
				accept_text: 'Delete Account and All its Installations',
				type: 'warning'
			});

			if (force_delete)
				options.force = true;
		}

		let response;
		try {
			response = await $.postJSON('pscm/api/account/delete', Object.assign(options, {account_id: this.account_id()}));
			if (response?.status === 'OK') {
				Grape.alert({type:'success', title:'Account Deleted', message:`Account "${this.account_name()}" deleted.`});
				return response;
			}
		} catch(err) {
			response = err.responseJSON;
		}

		Grape.alert_api_error(response);
		return response;
	}
}

export default Account;
